module.exports = "https://static.wmbcdn.com/uniweb/images/4102317f07e0852b4f9f40b9efd708d4.svg";